import React, { useState, useRef, useEffect } from "react";
import "./currencyDropdown.css";

const CurrencyDropdown = ({ selectedCurrency, onCurrencyChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currencies = [
    { code: "GBP", name: "British Pounds", symbol: "£", flag: "🇬🇧" },
    { code: "PKR", name: "Pakistani Rupees", symbol: "Rs.", flag: "🇵🇰" }
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCurrencySelect = (currency) => {
    onCurrencyChange(currency.code);
    setIsOpen(false);
  };

  const currentCurrency = currencies.find(c => c.code === selectedCurrency);

  return (
    <div className="currency-dropdown" ref={dropdownRef}>
      <button 
        className="currency-dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="currency-flag">
          {currentCurrency?.flag}
        </span>
        <span className="currency-text">
          {currentCurrency?.symbol} {currentCurrency?.name}
        </span>
        <span className={`currency-arrow ${isOpen ? "open" : ""}`}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </span>
      </button>
      
      {isOpen && (
        <div className="currency-dropdown-menu">
          {currencies.map((currency) => (
            <div
              key={currency.code}
              className={`currency-item ${selectedCurrency === currency.code ? "selected" : ""}`}
              onClick={() => handleCurrencySelect(currency)}
            >
              <span className="currency-flag">
                {currency.flag}
              </span>
              <span className="currency-info">
                <span className="currency-symbol">{currency.symbol}</span>
                <span className="currency-name">{currency.name}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencyDropdown;